import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
      const [user, setUser] = useState(null);
      const [userData, setUserData] = useState(null); // 🔥 NEW
      const auth = getAuth();

      // 🔥 LOGOUT FUNCTION
      const handleLogout = useCallback(async () => {
            try {
                  await signOut(auth);
                  localStorage.clear();
                  sessionStorage.clear();
                  window.location.href = "/login";
            } catch (err) {
                  console.error("Logout error:", err);
            }
      }, [auth]);

      // 🔥 FETCH USER DATA FROM FIRESTORE
      const fetchUserData = async (uid) => {
            try {
                  const docRef = doc(db, "users", uid);
                  const snap = await getDoc(docRef);

                  if (snap.exists()) {
                        setUserData(snap.data());
                  } else {
                        setUserData(null);
                  }
            } catch (err) {
                  console.error("UserData error:", err);
            }
      };


      // 🔥 AUTH STATE
      useEffect(() => {
            const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
                  setUser(currentUser);

                  if (currentUser) {
                        fetchUserData(currentUser.uid); // 🔥 fetch data
                  } else {
                        setUserData(null);
                  }
            });

            return () => unsubscribe();
      }, [auth]);

      return (
            <AuthContext.Provider value={{ user, userData, handleLogout }}>
                  {children}
            </AuthContext.Provider>
      );
};